import { render, staticRenderFns } from "./siteblocks-header.vue?vue&type=template&id=42d8ad74"
import script from "./siteblocks-header.vue?vue&type=script&lang=js"
export * from "./siteblocks-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports